import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ColorEnum } from '@shared/core/enums/color.enum';
import { IRouterLinksContainer } from '@utils/src/layout/interfaces/router-link.interface';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
})
export class PublicLayoutComponent implements OnInit {
  public footerLinks: IRouterLinksContainer[] = [
    {
      headerText: 'app.footer.header.carrier',
      headerColor: ColorEnum.ORANGE_16,
      links: [
        { text: 'app.footer.links.carrier', link: `https://pickwings.ch/${this._translate.currentLang}/transport-partner`, fragment: '', external: true, },
        { text: 'app.footer.links.carrier_benefits', link: `https://pickwings.ch/${this._translate.currentLang}/transport-partner/benefits`, fragment: '', external: true, },
        { text: 'app.footer.links.carrier_tools', link: `https://pickwings.ch/${this._translate.currentLang}/transport-partner/tools`, fragment: '', external: true, },
        { text: 'app.footer.links.carrier_program', link: `https://pickwings.ch/${this._translate.currentLang}/transport-partner/partner-program`, fragment: '', external: true, },
        { text: 'app.footer.links.help_center', link: `https://pickwings.ch/${this._translate.currentLang}/transport-partner/help`, fragment: '', external: true, },
      ],
    },
    {
      headerText: 'app.footer.header.company',
      headerColor: ColorEnum.WHITE_EF,
      links: [
        {
          text: 'app.footer.links.about',
          link: `https://pickwings.ch/${this._translate.currentLang}/about`, fragment: '', external: true,
        },
        { text: 'app.footer.links.more_trees', link: `https://pickwings.ch/${this._translate.currentLang}/green-logistics/trees`, fragment: '', external: true, },
        { text: 'app.footer.links.empty_km', link: `https://pickwings.ch/${this._translate.currentLang}/green-logistics/empty-kilometres`, fragment: '', external: true, },
        { text: 'app.footer.links.blog', link: `https://pickwings.medium.com/`, external: true, arrowType: 'no' },
        { text: 'app.footer.links.api_documentation', link: `https://pickwings.ch/${this._translate.currentLang}/api-documentation`, fragment: '', external: true, },
      ],
    },
  ];

  constructor(
    private _translate: TranslateService
  ) { }

  ngOnInit(): void { }
}
